<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <div class="flex flex-col gap-(--space-6)">
    <div class="flex flex-col gap-(--space-2)">
      <label for="name" class="font-medium">{{ 'common.labels.name' | transloco }}<sup>*</sup></label>
      <input
        id="name"
        type="text"
        pInputText
        formControlName="name"
        [attr.aria-required]="true"
        class="w-full"
        [class.p-invalid]="nameInvalid()"
        [attr.aria-invalid]="nameInvalid() || null"
        [attr.aria-describedby]="nameNotUnique() ? 'graph-name-error' : null"
        [maxlength]="100" />
      @if (nameNotUnique()) {
        <small id="graph-name-error" role="alert" class="text-(color:--p-red-500)">{{ nameNotUniqueMessage() }}</small>
      }
    </div>

    <div class="flex flex-col gap-(--space-3)">
      <label class="font-medium">
        {{ 'common.labels.type' | transloco }}
        @if (isTypeEditable()) {
          <sup>*</sup>
        }
      </label>
      <div
        role="radiogroup"
        [attr.aria-label]="'common.labels.type' | transloco"
        [attr.aria-invalid]="typeInvalid() ? 'true' : null"
        class="grid grid-cols-3 gap-(--space-3)"
        [class]="typeInvalid() ? 'border border-(color:--p-red-500) rounded-[var(--radius-md)] p-(--space-2)' : ''">
        @for (type of graphTypes; track type.value) {
          <div
            role="radio"
            [attr.aria-checked]="isTypeSelected(type.value)"
            [attr.aria-disabled]="isTypeEditable() ? null : 'true'"
            [attr.tabindex]="isTypeEditable() ? 0 : -1"
            (click)="selectType(type.value)"
            (keydown.enter)="selectType(type.value)"
            (keydown.space)="$event.preventDefault(); selectType(type.value)"
            [class]="getCardClass(type.value)"
            class="relative flex flex-col items-center gap-(--space-2) p-(--space-3) border rounded-[var(--radius-md)] transition-all focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-(color:--p-primary-color)">
            <span
              role="img"
              [attr.aria-label]="type.descriptionKey | transloco"
              class="absolute top-2 right-2 w-5 h-5 flex items-center justify-center rounded-full bg-(--p-gray-200) text-(color:--text-secondary) cursor-help"
              [pTooltip]="type.descriptionKey | transloco"
              tooltipPosition="top"
              (click)="$event.stopPropagation()">
              <i class="pi pi-info text-base" aria-hidden="true"></i>
            </span>
            <div class="w-full aspect-[4/3] flex items-center justify-center bg-[var(--surface-1)] rounded-[var(--radius-sm)]">
              <img [src]="type.image" [alt]="type.labelKey | transloco" class="w-full h-full object-contain p-(--space-2)" />
            </div>
            <span class="text-base text-(color:--text-primary) text-center">{{ type.labelKey | transloco }}</span>
          </div>
        }
      </div>
    </div>

    <div class="flex flex-col gap-(--space-2)">
      <label for="description" class="font-medium">{{ 'common.labels.description' | transloco }}</label>
      <textarea id="description" pTextarea formControlName="description" rows="4" class="w-full resize-none"></textarea>
    </div>

    <ces-dialog-footer [submitDisabled]="form.invalid" (onSubmit)="onSubmit()" (onCancel)="onCancel()" />
  </div>
</form>
